import { useState } from "react"
import { coreRequest } from "services/requests"

const prefix = "uiSettings"
const sendRequest = coreRequest.sendRequest
const useApi = () => {
  const [isFetching, setIsFetching] = useState(false)

  const getUiSettings = async () => {
    setIsFetching(true)
    const response = await sendRequest({
      endpoint: `${prefix}`,
      method: "get",
    })
    if (!response.success) console.log(response.message)
    setIsFetching(false)
    return response.data || null
  }

  const setUiSettings = async ({ theme = "light" }) => {
    setIsFetching(true)
    const response = await sendRequest({
      endpoint: `${prefix}`,
      body: { theme },
      method: "post",
    })
    if (!response.success) console.log(response.message)
    setIsFetching(false)
    return response.data || null
  }

  return {
    getUiSettings,
    setUiSettings,
    isFetching,
  }
}

export default useApi
